import { Button, Icon, Text } from '../../common/components';
import { t } from '../../common/i18n';

const namespace = 'Deadlines';

interface DeadlineTipProps {
  onAdd: () => void;
}

/** Nápověda na hlavní stránce – vede předsedu k zadání vlastních termínů (revize, pojistka, PENB…). */
export const DeadlineTip: React.FC<DeadlineTipProps> = ({ onAdd }) => (
  <div className="DeadlineTip">
    <div className="DeadlineTip__icon">
      <Icon name="info" />
    </div>
    <div className="DeadlineTip__body">
      <Text as="div" size="body-medium" weight="600" color="Neutral800">
        {t('tip.title', namespace)}
      </Text>
      <Text as="div" size="body-small" color="Neutral700">
        {t('tip.text', namespace)}
      </Text>
    </div>
    <Button size="small" title={t('tip.action', namespace)} onClick={onAdd} />
  </div>
);

export default DeadlineTip;
